module.exports = __webpack_public_path__ + "static/media/long-realistic.c8589acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vans/long-realistic.png
// module id = 884
// module chunks = 0